<template>
  <div id="page-beneficiary-view" class="mh-5">
    <beneficiary-form
      ref="beneficiaryForm"
      readonly
      v-model="model"
      card-title="Details"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button @click="goBack" class="mt-2"> Back </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            v-if="componentAccess.canEdit && componentAccess.canEdit.access"
            @click="goToEdit"
            class="mt-2"
            color="light"
            :disabled="loading"
          >
            Edit
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeneficiaryForm from '@/views/pages/user/beneficiaries/BeneficiaryForm';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';
import { EMPTY_BENEFICIARY_MODEL } from '@/views/pages/user/beneficiaries/constants';

export default {
  name: 'BeneficiaryView',
  components: {
    BeneficiaryForm,
  },
  mixins: [NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      model: { ...EMPTY_BENEFICIARY_MODEL },
      componentAccess: {
        canEdit: {
          route: 'contact.beneficiaries.edit',
          access: false,
        },
        canDelete: {
          route: '',
          access: false,
        },
        canRestore: {
          route: '',
          access: false,
        },
      },
    };
  },
  computed: {
    userId() {
      return this.$route.params.id;
    },
  },
  methods: {
    /**
     * Fetch beneficiary data for the current user.
     * If no beneficiary exists, initializes with empty values.
     */
    async fetch() {
      try {
        this.loading = true;
        const beneficiary = await this.$api.users.beneficiaries.getSingle(this.userId);
        this.model = beneficiary || { ...EMPTY_BENEFICIARY_MODEL };
      } catch (error) {
        console.error('Error fetching beneficiary:', error);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: 'Failed to load beneficiary details',
          position: 'top-right',
        });
        // Initialize with empty values on error
        this.model = { ...EMPTY_BENEFICIARY_MODEL };
      } finally {
        this.loading = false;
      }
    },
    /**
     * Navigate to edit screen.
     */
    goToEdit() {
      this.$router.push({
        name: 'contact.beneficiaries.edit',
        params: { id: this.userId },
      });
    },
    /**
     * Navigate back to contact view.
     */
    goBack() {
      this.$router.push({
        name: 'contact.view',
        params: { id: this.userId },
      });
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>

<style scoped>
</style>
